var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center m-5"},[_c('b-row',{staticClass:"my-5 d-flex justify-content-center"},[_c('b-col',{attrs:{"sm":"8","align-v":"center"}},[_c('h1',{staticClass:"text-info"},[_vm._v("مصرفنا")]),_c('div',{staticClass:"mb-3 p-1",attrs:{"id":"content"},domProps:{"innerHTML":_vm._s(_vm.about)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }